module.exports = __webpack_public_path__ + "static/media/LogicWedge5_5_1.0255f31d.png";